import { render, staticRenderFns } from "./ListDetails.vue?vue&type=template&id=40bccbc7&scoped=true&"
import script from "./ListDetails.vue?vue&type=script&lang=js&"
export * from "./ListDetails.vue?vue&type=script&lang=js&"
import style0 from "./ListDetails.vue?vue&type=style&index=0&id=40bccbc7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bccbc7",
  null
  
)

export default component.exports